/**
 * ASM-985: what the test editor's pages need to know about the lock session. The session
 * itself (timers, requests) lives in ./session.js, which writes this slice.
 */
export const SET_EDIT_LOCK_STATE = '[editLock] set state'

export const END_REASONS = {
  HELD: 'held', // another co-author holds it
  STALE: 'stale', // this tab's copy is out of date (with or without a newer version)
  SIGN_IN: 'signIn', // the login changed or ended
  ACCESS: 'access', // edit access was removed
  ERROR: 'error',
}

/**
 * Tabs a co-author the lock blocks does not get: the read-only view's tabs (TestPageHeader
 * drops the first two for a non-owner), named so a sections test loses Add Items too.
 */
export const EDIT_LOCK_HIDDEN_TABS = [
  'description',
  'manageSections',
  'addItems',
]

export const initialState = {
  active: false,
  testId: null,
  editing: false,
  acquireState: 'none',
  required: false,
  heldByThisTab: false,
  heldByOther: false,
  holderName: '',
  ended: false,
  endReason: null,
  activeTestId: null,
}

export const setEditLockStateAction = (payload) => ({
  type: SET_EDIT_LOCK_STATE,
  payload,
})

export const editLock = (state = initialState, { type, payload }) => {
  if (type === SET_EDIT_LOCK_STATE) return { ...initialState, ...payload }
  return state
}

export const getEditLockSelector = (state) => state.editLock || initialState

/**
 * True when the lock is what stops this tab editing (F1): its session ended, another
 * co-author is known to hold it, or the tab is editing a test that needs the lock and does
 * not hold it. A published test only being viewed is not blocked: Edit is how the lock is
 * taken.
 */
export const getIsEditBlockedByLockSelector = (state) => {
  const lock = getEditLockSelector(state)
  return !!(
    lock.active &&
    (lock.ended ||
      lock.heldByOther ||
      (lock.editing && lock.required && !lock.heldByThisTab))
  )
}

/**
 * The lock has not answered this tab yet: it is editing a test that needs the lock and its
 * first acquire is unsent or in flight. Blocked, but not refused (a retry is an answer).
 */
export const isAwaitingLockAnswer = (lock) =>
  !!(
    lock.active &&
    !lock.ended &&
    !lock.heldByOther &&
    lock.editing &&
    lock.required &&
    (lock.acquireState === 'none' || lock.acquireState === 'pending')
  )

/**
 * A hidden tab (Description, Add Items, Manage Sections) is left for Review, and the header
 * stops offering those tabs, only once the lock has refused this tab, not while the first
 * acquire is still waiting for its answer.
 */
export const getShouldLeaveHiddenTabSelector = (state) =>
  getIsEditBlockedByLockSelector(state) &&
  !isAwaitingLockAnswer(getEditLockSelector(state))

/** Preview-modal controls take only this term (F2): ended, or someone else is known to hold it. */
export const getIsLockedForPreviewControlsSelector = (state) => {
  const lock = getEditLockSelector(state)
  return !!(lock.active && (lock.ended || lock.heldByOther))
}
